import store from '@/store'
import router from '@/router'

export default [{
  name: 'dashboard',
  path: '/dashboard',
  beforeEnter(to, from, next) {
    let user = store.getters['auth/getProfile']
    if (
      !user.store.business_license_number &&
      !['no_cfa_account', 'not_cfa_account'].includes(status.code)
    ) {
      router.push({ name: 'cardsales/list' })
    } else {
      next()
    }
  },
  component: require('@/views/dashboard/Dashboard.vue').default
}]
